'use client'
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { sdkApi } from './api.js';

const fetchNonce = (environmentId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield sdkApi().getNonce({
            environmentId,
        });
        return res.nonce;
    }
    catch (e) {
        return undefined;
    }
});

export { fetchNonce };
